<template>
  <div class="gtss">
    <slot></slot>
  </div>
</template>

<script>
  export default {};
</script>

<style scoped lang="scss">
  .gtss {
    pointer-events: none;
    //
    width: 110%;
    height: 110%;
    //
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: z('above-default');
    //
    text-align: left;
    margin-bottom: 32px;
  }
</style>
